<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Problem of the Evil Editor</span></p>
<p class="subtitle"><span>A Charles Dodgson and Arthur Conan Doyle Mystery</span></p>
<p class="authorname"><span>Roberta Rogow</span></p>
<p class="publisher"><span><img alt="image" class="svg" src="images/fig_01.jpg"/><br/>MYSTERIOUSPRESS.COM</span></p>
<p class="publisher1"><span><img alt="image" class="svg" src="images/fig_02.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?2c4850c6